import PropTypes from 'prop-types';
import React from 'react';
import { Dropdown } from 'semantic-ui-react'
import { compose, lifecycle, withHandlers, withState } from 'recompose';
import { UnitsApiService } from './../../api';

const UnitSelect = ({ units, onChange, value }) =>
    <Dropdown
        noResultsMessage="Brak wyników"
        onChange={onChange}
        options={units}
        placeholder="Wybierz jednostkę"
        search
        selection
        value={value} />

UnitSelect.propTypes = {
    units: PropTypes.array,
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.number
}

UnitSelect.defaultProps = {
    units: []
}

const enhance = compose(
    withState('units', 'setUnits', []),
    withHandlers({
        onChange: ({ name, onChange }) => (event, { value }) => onChange(name, value)
    }),
    lifecycle({
        async componentDidMount() {
            const { setUnits } = this.props;
            const units = await UnitsApiService.getUnits();
            const selectFormatUnits = units.map(({ id: value, name: text }) => ({ text, value }));
            setUnits(selectFormatUnits);
        }
    })
);

export default enhance(UnitSelect);


// WEBPACK FOOTER //
// ./src/components/form-fields/UnitSelect.js